import { createPortal } from "react-dom"
import { motion } from "motion/react"
import Loader from "../../components/Loader"

const BODY = "'Manrope', sans-serif"
const DISPLAY = "'Tilda Sans', sans-serif"
const SHEET_BG = "linear-gradient(160deg, #1a2d55 0%, #18133b 100%)"

type PaymentCheckingPopupProps = {
    title?: string
    description?: string
}

export default function PaymentCheckingPopup({
    title = "Проверяем оплату…",
    description = "Это может занять несколько секунд. Пожалуйста, не закрывайте страницу.",
}: PaymentCheckingPopupProps) {
    if (typeof document === "undefined") return null

    return createPortal(
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[290] flex items-center justify-center px-4"
            style={{ background: "rgba(10,18,42,0.85)", backdropFilter: "blur(8px)" }}
            role="status"
            aria-live="polite"
            aria-busy="true">
            <motion.div
                initial={{ y: 16, opacity: 0, scale: 0.98 }}
                animate={{ y: 0, opacity: 1, scale: 1 }}
                className="flex w-full max-w-sm flex-col items-center gap-4 px-6 py-8 text-center"
                style={{
                    background: SHEET_BG,
                    border: "1.5px solid rgba(255,255,255,0.12)",
                    borderRadius: 24,
                    boxShadow: "0 24px 64px rgba(0,0,0,0.5)",
                }}>
                <Loader />
                <p className="text-[20px] text-white" style={{ fontFamily: DISPLAY, fontWeight: 700 }}>
                    {title}
                </p>
                <p className="text-[14px] text-white/60" style={{ fontFamily: BODY, fontWeight: 600 }}>
                    {description}
                </p>
            </motion.div>
        </motion.div>,
        document.body,
    )
}
